const config = {
  api_key: process.env.REACT_APP_API_KEY,
};

export default config;
